"use client";
import { jsx } from "react/jsx-runtime";
import Text from "@ingka/text";
const InlineMessageHeading = (props) => {
  const { children, headingLevel, className, prefix } = props;
  return /* @__PURE__ */ jsx(
    Text,
    {
      prefix,
      textStyle: "Heading.XS",
      tagName: `h${headingLevel}`,
      className,
      children
    }
  );
};
var InlineMessageHeading_default = InlineMessageHeading;
export {
  InlineMessageHeading_default as default
};
